module.exports = __webpack_public_path__ + "img/complete.60f96313.svg";